export const keys = {
    SITE_KEY: "6LcvnUorAAAAAKIZGJCkiWMoqqdJC7jhPceB75S8",
  //   SECRET_KEY:"6LcvnUorAAAAAE5sxfxcBbJzXP-RRDLmAew_imiC"
  };
  